import styled from "react-emotion";

const SiteContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-family: ${props => props.dyslexic ? "OpenDyslexic" : "Noto Sans"};
`

export default SiteContainer;


// WEBPACK FOOTER //
// ./src/components/common/SiteContainer.js